import SiteNavbar from "./components/SiteNavbar";
import HeroSection from "./components/HeroSection";
import EntryOverview from "./components/EntryOverview";
import LatestAddressSection from "./components/LatestAddressSection";
import AppDownloadSection from "./components/AppDownloadSection";
import VerifySection from "./components/VerifySection";
import TroubleshootSection from "./components/TroubleshootSection";
import FeaturesSection from "./components/FeaturesSection";
import StarterGuideSection from "./components/StarterGuideSection";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="w-full min-w-0 bg-background-50">
      <SiteNavbar />
      <main>
        <HeroSection />
        <EntryOverview />
        <LatestAddressSection />
        <AppDownloadSection />
        <VerifySection />
        <TroubleshootSection />
        <FeaturesSection />
        <StarterGuideSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}